// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Video_Wrapper__29X_A","fadeIn":"Video_fadeIn__1nDVi","modalFadeIn":"Video_modalFadeIn__2dmf6","slideInFromRight":"Video_slideInFromRight__1AV47"};